// export const contactObj = {
// 	Tiktok: "https://www.tiktok.com/@fancymartin7?_t=8pxS3FQTdrK&_r=1",
// 	Linkedin: "https://www.linkedin.com/in/long-sheng-81763b26a/",
// 	Youtube: "https://www.youtube.com/@longsheng2019",
// 	Twitter: "https://twitter.com/longsheng2019",
// 	Pinterest: "https://www.pinterest.com/longshengmfg/",
// 	FaceBook: "https://www.facebook.com/profile.php?id=61558577050675",
// };
export const contactObj = {
	FaceBook: "https://www.facebook.com/profile.php?id=100090998793124&mibextid=LQQJ4d&mibextid=LQQJ4d",
	Tiktok: "https://www.tiktok.com",
	Linkedin: "https://www.linkedin.com/",
	Youtube: "https://www.youtube.com/",
	Twitter: "https://twitter.com/",
	Pinterest: "https://www.pinterest.com/",
	Instagram: "https://www.instagram.com/",
};

export const contactInfo = {
	email: "pre-sales@lightew.com",
	email2: "after-sales@lightew.com",
	phone: "+86 15811571603",
	whatsapp: "+8619124350372",
	wechat: "",
	address: "1020 Luxe Ave, Columbus, Ohio,43220",
	name: "Guangzhou Guangyao Technology Co., Ltd",
};

/** Regional warehouse labels use `contact` namespace in next-intl, e.g. warehouseRegionUs */
export const overseasWarehouses = [
	{ translationKey: "warehouseRegionUs", address: "5650 Grace PL, COMMERCE, CA, US, 90022" },
	{ translationKey: "warehouseRegionDe1", address: "Ginsheimer Str. 8, Ginsheim-Gustavsburg, Frankfurt, DE, 65462" },
	{ translationKey: "warehouseRegionDe2", address: "Märkische Straße 10, Bochum, Nordrhein-Westfalen, DE, 44866" },
	{ translationKey: "warehouseRegionEs", address: "Av. la Veguilla s/n, Nave G, CABANILLAS DEL CAMPO, GUADALAJARA, 19171" },
	{
		translationKey: "warehouseRegionRu1",
		address:
			"владение Склады 104, с2/2, микрорайон Белые Столбы, Домодедово, Московская область, 142050",
	},
	{
		translationKey: "warehouseRegionRu2",
		address:
			"Московская область, городской округ Химки, деревня Чёрная Грязь, территория Многофункциональный Логистический Парк, 1А",
	},
	{ translationKey: "warehouseRegionAu", address: "Gate 2 / Unit 8 / 40 Brodie St, Rydalmere NSW 2116" },
	{ translationKey: "warehouseRegionMx", address: "Av. del Peral 32, Joaquin Lopez Negrete, 54713 Cuautitlán Izcalli, México" },
] as const;
